import { NgModule } from '@angular/core';
import { BrandLogoDirective } from './brand-logo.directive';
import { LoginBackgroundDirective } from './login-background.directive';

@NgModule({
  declarations: [BrandLogoDirective, LoginBackgroundDirective],
  exports: [BrandLogoDirective, LoginBackgroundDirective]
})
export class BrandingModule {}
